import { optionSchema } from '@/common/schemas/option.schema';
import { z } from 'zod';

export const equipmentBlockSchema = z
  .object({
    scheduled_to_unblock_at: z
      .object({
        date: z.string().optional(),
        time: optionSchema.nullable().optional(),
      })
      .optional(),
    scheduled_to_unblock_at_str: z.string().optional(),
    block_reason: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
  })
  .superRefine((data, ctx) => {
    if (data.scheduled_to_unblock_at) {
      const { date, time } = data.scheduled_to_unblock_at
      const hasDate = date && date.trim() !== ''
      const hasTime = time && time.value

      if (hasDate && !hasTime) {
        return ctx.addIssue({
          path: ['scheduled_to_unblock_at', 'time'],
          code: z.ZodIssueCode.custom,
          message: 'Caso a data seja preenchida, a hora também deve ser.',
        })
      }

      if (!hasDate && hasTime) {
        return ctx.addIssue({
          path: ['scheduled_to_unblock_at', 'date'],
          code: z.ZodIssueCode.custom,
          message: 'Caso a hora seja preenchida, a data também deve ser.',
        })
      }

      if (hasDate && hasTime) {
        const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/
        if (!dateRegex.test(date)) {
          return ctx.addIssue({
            path: ['scheduled_to_unblock_at', 'date'],
            code: z.ZodIssueCode.custom,
            message: 'Data inválida',
          })
        }

        const [day, month, year] = date.split('/').map(Number)
        const dateObj = new Date(year, month - 1, day)

        if (dateObj.getDate() !== day || dateObj.getMonth() !== month - 1 || dateObj.getFullYear() !== year) {
          return ctx.addIssue({
            path: ['scheduled_to_unblock_at', 'date'],
            code: z.ZodIssueCode.custom,
            message: 'Data inválida',
          })
        }

        const [hours, minutes] = hasTime.split(':').map(Number)
        const scheduledDateTime = new Date(year, month - 1, day, hours, minutes)
        const now = new Date()

        if (scheduledDateTime < now) {
          return ctx.addIssue({
            path: ['scheduled_to_unblock_at', 'date'],
            code: z.ZodIssueCode.custom,
            message: 'A data e hora de desbloqueio não podem estar no passado',
          })
        }
      }
    }
  });

export type EquipmentBlockValidationSchema = z.infer<typeof equipmentBlockSchema>;
